import { jsx as _jsx } from "react/jsx-runtime";
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import { useTranslation } from 'react-i18next';
/**
 * Marks a feature as beta next to its name. Deliberately quiet: it labels the
 * maturity of the feature without competing with the label it sits beside.
 */
export function BetaBadge({ className }) {
    const { t } = useTranslation('common');
    return (_jsx(Badge, { variant: "outline", className: cn('border-[#3FB4A8]/40 px-1.5 py-0 text-[10px] leading-4 font-medium tracking-wide text-[#3FB4A8] uppercase', className), children: t('badge.beta') }));
}
